import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function DepartmentList() {
  const navigate = useNavigate();
  const columns = [
    { field: "DL_Id", label: "#" },
    { field: "DL_Name", label: "Department" },
    { field: "DL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.DL_Id));

        navigate(
          `/DepartmentLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Department/list`}
      actions={actions}
      title={`Department`}
      linkvalue={`/DepartmentLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default DepartmentList;
